export default "__VITE_ASSET__CdeKmur9__"